"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Channels() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const departments = [{
    number: "01",
    label: "MISSION OPS",
    description: "For strategic partnerships and orbital intelligence integration inquiries.",
    email: "ops@tialinx.com",
    phone: "+1 (800) 555-0199",
    contactName: "Director Vance",
    contactRole: "Operations"
  }, {
    number: "02",
    label: "SYSTEM UPLINK",
    description: "Technical support for active sensing arrays and data stream maintenance.",
    email: "uplink@tialinx.com",
    phone: "+1 (800) 555-0188",
    contactName: "Eng. Kael",
    contactRole: "Systems"
  }, {
    number: "03",
    label: "INTEL BRIEF",
    description: "Media inquiries, research publications, and aerospace industry briefings.",
    email: "brief@tialinx.com",
    phone: "+1 (800) 555-0177",
    contactName: "Agent Thorne",
    contactRole: "Communications"
  }, {
    number: "04",
    label: "TALENT ACQ",
    description: "Join the command team defining the future of orbital intelligence.",
    email: "talent@tialinx.com",
    phone: "+1 (800) 555-0166",
    contactName: "Director Vance",
    contactRole: "Operations"
  }];
  return <>
    {false && <section data-section-id="4795" id="direct-channels" className="bg-[#080F1A] text-[#B2BDC7] py-24 md:py-32 lg:py-48 px-6 md:px-10 lg:px-12">
      <div ref={ref} className={`max-w-[1440px] mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 mb-20 md:mb-28 lg:mb-32">
          <div className="lg:col-span-7">
            <div className="font-default text-[0.875rem] tracking-[0.2em] text-[#6697B9] mb-8 md:mb-10">
              [TLX-04] DIRECT CHANNELS
            </div>
            <h2 className="font-default font-semibold text-5xl md:text-7xl lg:text-[4.5rem] leading-[1.1] tracking-[-0.02em] text-[#B2BDC7]">
              Command{" "}
              <span className="text-[#6697B9]">
                Uplink.
              </span>
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex lg:items-end">
            <p className="text-lg md:text-xl leading-[1.6] text-[#B2BDC7]" style={{
              fontFamily: "var(--font-default)"
            }}>
              Direct access to TiaLinx, Inc. mission control. Select your sector to initiate secure communication.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-[#45596F]">
          {departments.map((dept, i) => <div data-index={i} key={dept.number} className={`group relative flex flex-col px-0 md:px-8 lg:px-10 py-12 md:py-14 transition-colors duration-500 hover:bg-[#0f1a2e] ${i < departments.length - 1 ? "border-b border-[#45596F] md:border-b lg:border-b-0" : ""} ${i % 2 === 0 ? "md:border-r md:border-[#45596F]" : ""} ${i < 2 ? "md:border-b md:border-[#45596F] lg:border-b-0" : ""} lg:border-r lg:border-[#45596F] lg:last:border-r-0`}>
              <div className="font-default text-[0.75rem] tracking-[0.1em] text-[#6697B9] mb-10 md:mb-14">
                {dept.number} / {dept.label}
              </div>

              <p className="text-xl leading-[1.6] text-[#B2BDC7] mb-14 md:mb-20 flex-1" style={{
              fontFamily: "var(--font-default)"
            }}>
                {dept.description}
              </p>

              <div className="space-y-6">
                <div>
                  <div className="font-default text-[0.75rem] tracking-[0.1em] text-[#45596F] mb-2">
                    UPLINK
                  </div>
                  <Link to="mailto:info@tialinx.com" className="text-base text-[#B2BDC7] hover:text-[#6697B9] transition-colors duration-300 break-all" style={{
                  fontFamily: "var(--font-default)"
                }}>
                    info@tialinx.com
                  </Link>
                </div>

                <div>
                  <div className="font-default text-[0.75rem] tracking-[0.1em] text-[#45596F] mb-2">
                    VOICE
                  </div>
                  <Link to={`tel:${dept.phone.replace(/[^\d+]/g, "")}`} className="text-base text-[#B2BDC7] hover:text-[#6697B9] transition-colors duration-300" style={{
                  fontFamily: "var(--font-default)"
                }}>
                    {dept.phone}
                  </Link>
                </div>

                <div>
                  <div className="font-default text-[0.75rem] tracking-[0.1em] text-[#45596F] mb-2">
                    AUTHORITY
                  </div>
                  <div className="text-base text-[#B2BDC7]" style={{
                  fontFamily: "var(--font-default)"
                }}>
                    <span>{dept.contactName}</span>
                    <span className="text-[#45596F]"> / </span>
                    <span>{dept.contactRole}</span>
                  </div>
                </div>

                <div className="pt-8">
                  <Link to="mailto:info@tialinx.com" className="inline-flex items-center gap-2 font-default text-[0.75rem] tracking-[0.1em] text-[#6697B9] hover:gap-4 transition-all duration-300">
                    <ArrowRight className="size-3" />
                    INITIATE UPLINK
                  </Link>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>}
  </>;
}